export default function setup() {
  
}

export function showNotification(message, type) {
    var notificationContainer = $('#alert-notification-container');

    // Create a new alert element
    var newAlert = $('<div class="alert"></div>');
    var notificationTitle = $('<strong></strong>');
    var notificationMessage = $('<div role="alert"></div>');

    // Set the message and type
    if (type === "success") {
        notificationTitle.text("Success");
        newAlert.addClass("alert-success");
    } else if (type === "error") {
        notificationTitle.text("Error");
        newAlert.addClass("alert-danger");
    }

    notificationMessage.text(message);

    // Append the title and message to the new alert element
    newAlert.append(notificationTitle).append(notificationMessage);

    // Append the new alert to the notifications container
    notificationContainer.append(newAlert);

    // Show the alert with a fade-in effect
    newAlert.fadeIn(200);

    // Automatically hide the alert after 3 seconds (fade out over 2 seconds)
    setTimeout(function () {
        newAlert.fadeOut(2000, function() {
            // Remove the alert from the DOM after it fades out
            newAlert.remove();
        });
    }, 3000);
}